export var Registry;
(function (Registry) {
    Registry["RKI"] = "RKI";
    Registry["DEBITOR_REGISTRET"] = "DEBITOR_REGISTRET";
})(Registry || (Registry = {}));
export var RegistryType;
(function (RegistryType) {
    RegistryType["OPEN"] = "open";
    RegistryType["CLOSED"] = "closed";
})(RegistryType || (RegistryType = {}));
export var DebtRegistrationState;
(function (DebtRegistrationState) {
    DebtRegistrationState["ACTIVE"] = "ACTIVE";
    DebtRegistrationState["DELETED"] = "DELETED";
    DebtRegistrationState["CONCLUDED"] = "CONCLUDED";
    DebtRegistrationState["ERROR"] = "ERROR";
})(DebtRegistrationState || (DebtRegistrationState = {}));
export var DebtRegistrationHistoryType;
(function (DebtRegistrationHistoryType) {
    DebtRegistrationHistoryType["Created"] = "CREATED";
    DebtRegistrationHistoryType["StateChange"] = "STATE_CHANGE";
    DebtRegistrationHistoryType["RegistryTypeChange"] = "REGISTRY_TYPE_CHANGE";
    DebtRegistrationHistoryType["CaseChange"] = "CASE_CHANGE";
    DebtRegistrationHistoryType["RegistryPatch"] = "REGISTRY_PATCH";
})(DebtRegistrationHistoryType || (DebtRegistrationHistoryType = {}));
//# sourceMappingURL=index.js.map